$font_family: Galano Grotesque, Segoe UI, sans-serif;

.isSubmitting {
  pointer-events: none;
  cursor: default;
  overflow: hidden;
}

.buttonClass {
  font-family: $font_family !important;
  cursor: pointer;
  position: relative;
  border: 0;
  line-height: 1;
  transition: background-color 0.25s ease-out;
  text-decoration: unset;
  height: 36px;
  padding: 0 15px;

  &:hover {
    transition: background-color 0.25s ease-in;
  }

  @include themify($themes) {
    color: themed("main-primary");
  }
  &:disabled {
    pointer-events: none;
    opacity: 0.4;
  }
  
  &:disabled.hasSvg svg {
    cursor: default;
  }
}
a.buttonClass {
  align-items: center;
  display: flex;
}

.hasSvg {
  display: flex;
  align-items: center;
  column-gap: 12px;
}

.submitSpan {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  z-index: 3;
  background: inherit;
  width: 100%;
  display: flex;
  height: 100%;
  align-items: center;
  justify-content: center;
}

.primary {
  @include themify($themes) {
    background-color: themed("btn-primary");
    color: themed("btn-primary-text");

    &:not(:disabled):hover {
      background-color: themed("btn-primary-hover");
    }
  }
}

.secondary {
  @include themify($themes) {
    background-color: themed("btn-secondary");

    &:not(:disabled):hover {
      background-color: themed("btn-secondary-hover");
    }
  }
}

.link {
  @include themify($themes) {
    background-color: themed("btn-link");
  }
}
